/**************************************************
 * hooks/useOrganData.js
 *
 * @author  LSJ
 * @since   1.0 (2025-02-28)
 * @version 1.0
 **************************************************/
import { useDashboardData } from "@hooks";

/**
 * useOrganData
 *
 * params 객체를 기반으로 "/user/dash/organ" 또는 "/user/dash/organ/site" 데이터를 불러오는 커스텀 훅.
 * siteCode가 있으면 사업장별 조회, 없으면 전체 조회를 수행합니다.
 * React Query의 useQuery를 사용하여 상태(data, isLoading, isError, error, refetch)를 관리합니다.
 * params 객체는 예: { compCode, siteCode, otherParam } 와 같이 구성됩니다.
 *
 * @param   {object}  params  API 호출에 사용할 파라미터 객체 (예: { compCode, siteCode, ... })
 * @returns {object}          { data, isLoading, isError, error, refetch }
 */
const useOrganData = (params) => {
  const endpoint = params?.siteCode ? "/user/dash/organ/site" : "/user/dash/organ";
  return useDashboardData(endpoint, "organData", params, "get");
};

export default useOrganData;
